import React, { useCallback, useRef } from "react";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
const PopupWhishNote = (props) => {
  const ref = useRef(null);
  const { closeModal, hasInfor, imageUrl, wishContent } = props;
  const handleSaveImage = useCallback(() => {
    if (ref.current === null) {
      return;
    }

    toPng(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "my-image-name.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [ref]);
  return (
    <>
      <div className="popup-overlay modal-whish">
        <div className="popup-warp">
          {hasInfor && (
            <div
              className="close-modal"
              onClick={() => {
                closeModal();
              }}
            ></div>
          )}

          <div className="popup-inner">
            <img src="/assets/img/card-whish.png" />
            <p
              className="content-popup"
              dangerouslySetInnerHTML={{ __html: wishContent }}
            ></p>
            <div className="btn-wrapper btn-center">
              {hasInfor && <img src="assets/img/bt-wish-note.png" />}
              {!hasInfor && (
                <button
                  type="button"
                  className="btn btn-primary btn-border"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  QUAY LẠI
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupWhishNote;
